import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useUser } from './UserContext'; // Import the user context
import LoginPopup from './LoginPopup';
import './css/Header.css';

function Header() {
  const { user, logout } = useUser(); // Access user and logout from context
  const [isDropdownOpen, setIsDropdownOpen] = useState(false); // State for dropdown visibility

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  const handleOutsideClick = (event) => {
    if (!event.target.closest('.profile-container')) {
      setIsDropdownOpen(false);
    }
  };

  React.useEffect(() => {
    if (isDropdownOpen) {
      document.addEventListener('click', handleOutsideClick);
    } else {
      document.removeEventListener('click', handleOutsideClick);
    }
    return () => {
      document.removeEventListener('click', handleOutsideClick);
    };
  }, [isDropdownOpen]);

  return (
    <>
    <div className="header">
      <div className="logo">
        <Link to="/">službomat</Link>
      </div>
      <div className="login">
        {user ? (
          <div className="profile-container">
            <div className="profile" onClick={toggleDropdown}>
              {user.displayName || user.email} &nbsp; {" "}
              <i className={`fas ${isDropdownOpen ? "fa-chevron-up" : "fa-chevron-down"}`}></i>
            </div>
            <div className={`dropdown-menu ${isDropdownOpen ? 'open' : ''}`}>
              <ul>
                {/* <li>
                  <Link to="/home">Moje Konto</Link>
                </li>
                <li>
                  <Link to="/calendar">Kalendár</Link>
                </li> */}
                <li>
                  <Link to="/favorites">Obľúbené</Link>
                </li>
                <li>
                  <Link to="/seo">Pre Firmy </Link>
                </li>
                {/* <li>
                  <Link to="/dashboard">Prémium </Link>
                </li> */}
                <li>
                  <button className='logout' onClick={logout}>Odhlásiť</button>
                </li>
              </ul>
            </div>
          </div>
        ) : (
          <LoginPopup />
        )}
      </div>
      
    </div>
    {/* <div className='sub-header'>
    <Link to="/catalog?search=masaz">Masáže</Link>
    <Link to="/catalog?search=kozmetika">Kozmetika</Link>
    <Link to="/catalog?search=pedikura">Pedikúra</Link>
    <Link to="/catalog?search=manikura">Manikúra</Link>
    <Link to="/catalog?search=fitness">Fitness</Link>
    <Link to="/catalog?search=wellness">Wellness</Link>
    <Link to="/catalog?search=solarium">Solárium</Link>
    <Link to="/catalog?search=sauna">Sauna</Link>
    <Link to="/catalog?search=barber">Barber</Link>
    <Link to="/catalog?search=holic">Kaderník</Link>
    <Link to="/catalog?search=tattoo">Tetovanie</Link>
    <Link to="/catalog?search=pilates">Pilates</Link>
    <Link to="/catalog?search=yoga">Joga</Link>

    </div> */}
  </>
  );
}

export default Header;
